import { render, staticRenderFns } from "./addOrEditExam.vue?vue&type=template&id=653662b1&scoped=true&"
import script from "./addOrEditExam.vue?vue&type=script&lang=js&"
export * from "./addOrEditExam.vue?vue&type=script&lang=js&"
import style0 from "./addOrEditExam.vue?vue&type=style&index=0&id=653662b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653662b1",
  null
  
)

export default component.exports